import './PriceLevel.scss'
import React from 'react'
import BEMHelper from 'react-bem-helper'
import useTranslations from '@src/hooks/useTranslations'

import Button from '@material-ui/core/Button'

const bem = new BEMHelper('price-level')

function PriceLevel({ selected = false, priceLevel, onClick = () => {} }) {
	const t = useTranslations()

	return (
		<div {...bem('')}>
			<div {...bem('level')}>
				<div>{priceLevel.title}</div>
				<div>{`${priceLevel.monthlyCost} kr/mån`}</div>
			</div>
			<div>x kr/timme</div>
			<div>x kr/km</div>
			<div>{priceLevel.description}</div>
			{selected && (
				<div style={{ color: 'red' }}>
					This is selected in state, should this be resetedf on navigation to
					this page?
				</div>
			)}
			<Button
				color='primary'
				variant='outlined'
				onClick={() => onClick(priceLevel)}
			>
				{t('kinto.select')}
			</Button>
		</div>
	)
}

export default PriceLevel
